import { InputGroupV2, UniversalSelect } from '@equip.health/ui';

import {
  AgeRange,
  AGE_RANGE_DISPLAY_NAMES,
} from '~/lib/util/clinicalProfile.util';
import {
  GroupClassBaseFieldProps,
  GROUP_CLASS_ACCORDION_TOP_LEVEL_ID,
} from '~/lib/types/classes/GroupClassAccordion';

export const GroupClassAgeRangeField = ({
  value,
  onChange,
  leftIcon,
  isReadOnly = false,
  placeholder,
}: GroupClassBaseFieldProps<string[]>) => {
  const ageRangeOptions = Object.values(AgeRange).map((ageRange) => ({
    label: AGE_RANGE_DISPLAY_NAMES[ageRange],
    value: ageRange,
  }));

  const readOnlyProps = isReadOnly ? { inputValue: value?.join(', ') } : {};

  return (
    <InputGroupV2
      id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__age-range`}
      label="Age ranges"
    >
      <UniversalSelect
        id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__age-range-select`}
        isSingleSelect={false}
        onChange={(options) => {
          const selectedValues = Array.isArray(options)
            ? options.map((opt) => opt.value)
            : [];

          onChange(selectedValues);
        }}
        leftIcon={leftIcon}
        options={ageRangeOptions}
        placeholder={placeholder}
        isReadOnly={isReadOnly}
        value={ageRangeOptions?.filter((option) =>
          value?.includes(option.value),
        )}
        {...readOnlyProps}
        withCheckBox
      />
    </InputGroupV2>
  );
};
